import { C } from "../theme";
import { ZoneCard } from "../components/ZoneCard";
import type { DashboardState } from "../types";

export function Zones({
  state,
  pending,
  onRun,
  onStop,
  onStep,
  onToggle,
  onSelect,
}: {
  state: DashboardState;
  pending: Record<string, boolean>;
  onRun: (id: string, minutes: number) => void;
  onStop: (id: string) => void;
  onStep: (id: string, minutes: number) => void;
  onToggle: (id: string, enabled: boolean) => void;
  onSelect: (id: string) => void;
}) {
  const { zones } = state;

  const sprinkler = zones.filter((z) => z.type === "spray").length;
  const drip = zones.filter((z) => z.type === "drip").length;
  const watering = zones.filter((z) => z.state === "watering").length;
  const holds = zones.filter(
    (z) => z.state === "wind-hold" || z.state === "freeze-hold",
  ).length;
  const attention = zones.filter((z) => z.state === "off" && !z.enabled).length;

  return (
    <div>
      <div className="card-in" style={{ marginBottom: 18 }}>
        <p style={{ fontSize: 12.5, color: C.textMid, margin: 0 }}>
          {sprinkler} sprinkler · {drip} drip — {watering} watering, {holds} on hold,{" "}
          {attention} needs attention
        </p>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 270px), 1fr))",
          gap: 18,
        }}
      >
        {zones.map((z) => (
          <ZoneCard
            key={z.id}
            z={z}
            paused={state.paused}
            soilSrc={state.sources?.soil}
            flowSrc={state.sources?.flow}
            busyRun={!!pending[`run:${z.id}`]}
            busyStop={!!pending[`stop:${z.id}`]}
            onRun={onRun}
            onStop={onStop}
            onStep={onStep}
            onToggle={onToggle}
            onSelect={onSelect}
          />
        ))}
      </div>
    </div>
  );
}
